module.exports = __webpack_public_path__ + "static/media/20200523-164326-004.dd9132f5.png";